/**
 * Spec 105 — PersonaTypeBadge. Commercial vs informational persona type.
 */
import type { PersonaType } from '../api/personas.js';

/** Spec 230 — restyled onto `.hub-chip`. Neither type is a status, so the
 * tones are picked purely to keep the two visually distinct, as the original
 * indigo/teal pair did. */
const CONFIG: Record<PersonaType, { label: string; tone: 'info' | 'ok' }> = {
  commercial: { label: 'Commercial', tone: 'info' },
  informational: { label: 'Informational', tone: 'ok' },
};

export function PersonaTypeBadge({ personaType }: { personaType: PersonaType }) {
  const c = CONFIG[personaType];
  return (
    <span
      data-testid="persona-type-badge"
      data-persona-type={personaType}
      className={`hub-chip hub-chip--${c.tone}`}
    >
      {c.label}
    </span>
  );
}
